import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "import-location" };
const _hoisted_2 = { class: "mb-3" };
const _hoisted_3 = { class: "mb-3" };
const _hoisted_4 = { class: "mb-3" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 0,
    class: "mb-2 d-flex flex-wrap align-items-center gap-2"
};
const _hoisted_7 = { class: "fw-bold" };
const _hoisted_8 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_9 = {
    key: 1,
    class: "badge bg-warning text-dark"
};
const _hoisted_10 = {
    key: 2,
    class: "badge bg-warning text-dark"
};
const _hoisted_11 = {
    key: 3,
    class: "badge bg-danger"
};
const _hoisted_12 = {
    key: 4,
    class: "badge bg-secondary"
};
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    key: 1,
    class: "mb-3"
};
const _hoisted_15 = { class: "d-flex justify-content-between small mb-1" };
const _hoisted_16 = ["disabled"];
const _hoisted_17 = {
    key: 2,
    class: "alert alert-warning py-2 mb-2"
};
const _hoisted_18 = {
    key: 0,
    class: "d-flex flex-wrap align-items-center gap-2"
};
const _hoisted_19 = ["disabled"];
const _hoisted_20 = ["disabled"];
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
    key: 3,
    class: "import-files-table-wrapper mb-3"
};
const _hoisted_23 = { class: "table table-sm align-middle import-files-table" };
const _hoisted_24 = { class: "file-name" };
const _hoisted_25 = { class: "small text-muted" };
const _hoisted_26 = {
    key: 0,
    class: "small text-muted"
};
const _hoisted_27 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_28 = {
    key: 1,
    class: "small"
};
const _hoisted_29 = { class: "text-danger" };
const _hoisted_30 = { class: "fw-bold" };
const _hoisted_31 = {
    key: 0,
    class: "mb-0 small"
};
const _hoisted_32 = {
    key: 1,
    class: "support-reference mt-1"
};
const _hoisted_33 = {
    key: 0,
    class: "text-warning-emphasis fw-bold mb-1"
};
const _hoisted_34 = {
    key: 1,
    class: "text-success small"
};
const _hoisted_35 = { class: "small mb-1" };
const _hoisted_36 = { class: "form-check form-check-inline" };
const _hoisted_37 = ["name", "id", "onUpdate:modelValue", "disabled"];
const _hoisted_38 = ["for"];
const _hoisted_39 = { class: "form-check form-check-inline" };
const _hoisted_40 = ["name", "id", "onUpdate:modelValue", "disabled"];
const _hoisted_41 = ["for"];
const _hoisted_42 = { class: "small mb-1" };
const _hoisted_43 = { class: "form-check" };
const _hoisted_44 = ["id", "onUpdate:modelValue", "disabled"];
const _hoisted_45 = ["for"];
const _hoisted_46 = { class: "text-end" };
const _hoisted_47 = ["disabled", "onClick"];
const _hoisted_48 = { class: "mb-0" };
const _hoisted_49 = {
    key: 0,
    class: "text-danger me-auto"
};
const _hoisted_50 = {
    key: 1,
    class: "text-muted me-auto"
};
const _hoisted_51 = { key: 0 };
const _hoisted_52 = { key: 1 };
const _hoisted_53 = { key: 0 };
const _hoisted_54 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_progress = _resolveComponent("b-progress");
    const _component_b_alert = _resolveComponent("b-alert");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        id: "import-system-from-zip-modal",
        modelValue: _ctx.show,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.show) = $event)),
        title: "Import Controller Data",
        "header-bg-variant": "normal",
        size: "xl",
        scrollable: "",
        "no-close-on-backdrop": "",
        onHidden: _ctx.onModalHidden
    }, {
        footer: _withCtx(() => [
            (_ctx.rows.length && !_ctx.counts.unchecked && _ctx.importBlockedReason)
                ? (_openBlock(), _createElementBlock("small", _hoisted_49, _toDisplayString(_ctx.importBlockedReason), 1 /* TEXT */))
                : (_ctx.counts.rejected && _ctx.importableRows.length)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_50, "\r\n\t\t\t\tFiles that cannot be imported will be skipped.\r\n\t\t\t"))
                    : _createCommentVNode("v-if", true),
            _cache[67] || (_cache[67] = _createTextVNode()),
            _createVNode(_component_b_button, {
                type: "button",
                variant: "secondary",
                onClick: _ctx.cancel,
                disabled: _ctx.queueing
            }, {
                default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                        _createTextVNode("Cancel", -1 /* CACHED */)
                    ]))]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick", "disabled"]),
            _cache[68] || (_cache[68] = _createTextVNode()),
            (_ctx.counts.unchecked || _ctx.checking)
                ? (_openBlock(), _createBlock(_component_b_button, {
                    key: 2,
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.checkFiles,
                    disabled: !_ctx.canCheck
                }, {
                    default: _withCtx(() => [
                        (_ctx.checking)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, [...(_cache[63] || (_cache[63] = [
                                    _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Checking…", -1 /* CACHED */)
                                ]))]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                _cache[64] || (_cache[64] = _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)),
                                _createTextVNode(" Check " + _toDisplayString(_ctx.counts.unchecked) + " file" + _toDisplayString(_ctx.counts.unchecked === 1 ? "" : "s"), 1 /* TEXT */)
                            ]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick", "disabled"]))
                : (_openBlock(), _createBlock(_component_b_button, {
                    key: 3,
                    type: "button",
                    variant: "primary",
                    onClick: _ctx.queueImport,
                    disabled: !_ctx.canImport
                }, {
                    default: _withCtx(() => [
                        (_ctx.queueing)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, [...(_cache[65] || (_cache[65] = [
                                    _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                                    _createTextVNode(" Queuing…", -1 /* CACHED */)
                                ]))]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_54, [
                                _cache[66] || (_cache[66] = _createElementVNode("i", { class: "fa fa-upload" }, null, -1 /* CACHED */)),
                                _createTextVNode(" Import " + _toDisplayString(_ctx.importableRows.length) + " file" + _toDisplayString(_ctx.importableRows.length === 1 ? "" : "s"), 1 /* TEXT */)
                            ]))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick", "disabled"]))
        ]),
        default: _withCtx(() => [
            _cache[69] || (_cache[69] = _createTextVNode()),
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, [
                        _createTextVNode("Company "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1 /* CACHED */)),
                    _cache[11] || (_cache[11] = _createTextVNode()),
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedCompany,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompany) = $event)),
                        options: _ctx.companies,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "Select company",
                        class: "multiselect-small",
                        disabled: _ctx.busy
                    }, {
                        noResult: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                ]),
                _cache[15] || (_cache[15] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, [
                        _createTextVNode("Site "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1 /* CACHED */)),
                    _cache[14] || (_cache[14] = _createTextVNode()),
                    _createVNode(_component_multiselect, {
                        modelValue: _ctx.selectedSite,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedSite) = $event)),
                        options: _ctx.filteredSites,
                        "track-by": "value",
                        label: "text",
                        showLabels: false,
                        placeholder: "Select site",
                        class: "multiselect-small",
                        disabled: _ctx.busy || !_ctx.selectedCompany
                    }, {
                        noResult: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                ])
            ]),
            _cache[70] || (_cache[70] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _cache[16] || (_cache[16] = _createElementVNode("label", {
                    class: "form-label",
                    for: "importZipFiles"
                }, [
                    _createTextVNode("ZIP files "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1 /* CACHED */)),
                _cache[17] || (_cache[17] = _createTextVNode()),
                _createElementVNode("input", {
                    id: "importZipFiles",
                    ref: "fileInput",
                    type: "file",
                    class: "form-control",
                    accept: ".zip",
                    multiple: "",
                    disabled: _ctx.busy,
                    onChange: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.onFilesSelected && _ctx.onFilesSelected(...args)))
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_5),
                _cache[18] || (_cache[18] = _createTextVNode()),
                _cache[19] || (_cache[19] = _createElementVNode("small", { class: "form-text text-muted" }, "\r\n\t\t\t\tSelect one or more files for the selected site; you can add more files before importing. Each ZIP file must contain configuration.json and\r\n\t\t\t\tlimits.json, and may contain CSV files (clog-Yearly*.csv, tlog-charge*.csv, tlog-discharge*.csv). To import files for another site,\r\n\t\t\t\timport these first and then start again with the other site.\r\n\t\t\t", -1 /* CACHED */))
            ]),
            _cache[71] || (_cache[71] = _createTextVNode()),
            (_ctx.rows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.rows.length) + " file" + _toDisplayString(_ctx.rows.length === 1 ? "" : "s"), 1 /* TEXT */),
                    _cache[20] || (_cache[20] = _createTextVNode()),
                    (_ctx.counts.ready)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.counts.ready) + " ready", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _cache[21] || (_cache[21] = _createTextVNode()),
                    (_ctx.counts.needsChoice)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.counts.needsChoice) + " need a decision", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _cache[22] || (_cache[22] = _createTextVNode()),
                    (_ctx.counts.duplicate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.counts.duplicate) + " same controller", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _cache[23] || (_cache[23] = _createTextVNode()),
                    (_ctx.counts.rejected)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.counts.rejected) + " cannot be imported", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _cache[24] || (_cache[24] = _createTextVNode()),
                    (_ctx.counts.unchecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.counts.unchecked) + " not checked yet", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                    _cache[25] || (_cache[25] = _createTextVNode()),
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link btn-sm ms-auto",
                        disabled: _ctx.busy,
                        onClick: _cache[3] || (_cache[3] =
                            //@ts-ignore
                            (...args) => (_ctx.clearFiles && _ctx.clearFiles(...args)))
                    }, "Remove all", 8 /* PROPS */, _hoisted_13)
                ]))
                : _createCommentVNode("v-if", true),
            _cache[72] || (_cache[72] = _createTextVNode()),
            (_ctx.checking)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("span", null, [
                            _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */)),
                            _createTextVNode(" Checking file " + _toDisplayString(_ctx.checkProgress.current) + " of " + _toDisplayString(_ctx.checkProgress.total) + "…", 1 /* TEXT */)
                        ]),
                        _cache[27] || (_cache[27] = _createTextVNode()),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link btn-sm p-0",
                            disabled: _ctx.cancelRequested,
                            onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.cancelRequested = true))
                        }, "Stop", 8 /* PROPS */, _hoisted_16)
                    ]),
                    _cache[28] || (_cache[28] = _createTextVNode()),
                    _createVNode(_component_b_progress, {
                        value: _ctx.checkProgress.current - 1,
                        max: _ctx.checkProgress.total,
                        animated: ""
                    }, null, 8 /* PROPS */, ["value", "max"])
                ]))
                : _createCommentVNode("v-if", true),
            _cache[73] || (_cache[73] = _createTextVNode()),
            (_ctx.sameSiteChoiceRows.length > 1 || _ctx.differentSiteChoiceRows.length > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.sameSiteChoiceRows.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.sameSiteChoiceRows.length) + " controllers already have a system at this site. For all of them:", 1 /* TEXT */),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-outline-dark",
                                disabled: _ctx.busy,
                                onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.chooseForAll('override')))
                            }, "Override existing systems", 8 /* PROPS */, _hoisted_19),
                            _cache[30] || (_cache[30] = _createTextVNode()),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-outline-dark",
                                disabled: _ctx.busy,
                                onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.chooseForAll('archive')))
                            }, "Archive and create new systems", 8 /* PROPS */, _hoisted_20)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[32] || (_cache[32] = _createTextVNode()),
                    (_ctx.differentSiteChoiceRows.length > 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["d-flex flex-wrap align-items-center gap-2", { 'mt-2': _ctx.sameSiteChoiceRows.length > 1 }])
                        }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.differentSiteChoiceRows.length) + " controllers are registered at another location.", 1 /* TEXT */),
                            _cache[31] || (_cache[31] = _createTextVNode()),
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-outline-dark",
                                disabled: _ctx.busy,
                                onClick: _cache[7] || (_cache[7] =
                                    //@ts-ignore
                                    (...args) => (_ctx.confirmArchiveForAll && _ctx.confirmArchiveForAll(...args)))
                            }, "Archive them all and move them here", 8 /* PROPS */, _hoisted_21)
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true),
            _cache[74] || (_cache[74] = _createTextVNode()),
            (_ctx.rows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("table", _hoisted_23, [
                        _cache[58] || (_cache[58] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "File"),
                                _createTextVNode(),
                                _createElementVNode("th", null, "Controller"),
                                _createTextVNode(),
                                _createElementVNode("th", null, "Check result"),
                                _createTextVNode(),
                                _createElementVNode("th")
                            ])
                        ], -1 /* CACHED */)),
                        _cache[59] || (_cache[59] = _createTextVNode()),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                                var _a, _b, _c, _d, _e, _f, _g, _h;
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: row.key,
                                    class: _normalizeClass(_ctx.rowClass(row))
                                }, [
                                    _createElementVNode("td", _hoisted_24, [
                                        _createTextVNode(_toDisplayString(row.file.name) + " ", 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatSize(row.file.size)), 1 /* TEXT */)
                                    ]),
                                    _cache[55] || (_cache[55] = _createTextVNode()),
                                    _createElementVNode("td", null, [
                                        (row.preview && row.preview.serialNumber)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(row.preview.serialNumber) + " ", 1 /* TEXT */),
                                                (row.preview.systemName)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(row.preview.systemName), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ], 64 /* STABLE_FRAGMENT */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _cache[56] || (_cache[56] = _createTextVNode()),
                                    _createElementVNode("td", null, [
                                        _createCommentVNode(" Not checked / checking "),
                                        _cache[53] || (_cache[53] = _createTextVNode()),
                                        (row.state === 'Selected')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Not checked yet"))
                                            : (row.state === 'Checking')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, [...(_cache[33] || (_cache[33] = [
                                                        _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                                                        _createTextVNode(" Checking…", -1 /* CACHED */)
                                                    ]))]))
                                                : (row.state === 'Rejected')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createCommentVNode(" Cannot be imported "),
                                                        _createElementVNode("div", _hoisted_29, [
                                                            _createElementVNode("div", _hoisted_30, [
                                                                _cache[34] || (_cache[34] = _createElementVNode("i", { class: "fa fa-times-circle" }, null, -1 /* CACHED */)),
                                                                _createTextVNode(" " + _toDisplayString(row.message), 1 /* TEXT */)
                                                            ]),
                                                            _cache[36] || (_cache[36] = _createTextVNode()),
                                                            (row.errors.length)
                                                                ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.errors, (error, index) => {
                                                                        return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1 /* TEXT */));
                                                                    }), 128 /* KEYED_FRAGMENT */))
                                                                ]))
                                                                : _createCommentVNode("v-if", true),
                                                            _cache[37] || (_cache[37] = _createTextVNode()),
                                                            (row.errorReference)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                                    _cache[35] || (_cache[35] = _createTextVNode("Support reference: ", -1 /* CACHED */)),
                                                                    _createElementVNode("code", null, _toDisplayString(row.errorReference), 1 /* TEXT */)
                                                                ]))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                        _createCommentVNode(" Same controller in another file of this batch "),
                                                        _cache[51] || (_cache[51] = _createTextVNode()),
                                                        (_ctx.duplicateOf(row).length)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                                _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1 /* CACHED */)),
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tSame controller as " + _toDisplayString(_ctx.duplicateOf(row).join(", ")) + ". Only one file per controller can be imported at a time: keep the most recent file and remove the others.\r\n\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                            ]))
                                                            : _createCommentVNode("v-if", true),
                                                        _cache[52] || (_cache[52] = _createTextVNode()),
                                                        (row.state === 'Ready')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, [...(_cache[39] || (_cache[39] = [
                                                                    _createElementVNode("i", { class: "fa fa-check-circle" }, null, -1 /* CACHED */),
                                                                    _createTextVNode(" Ready: a new system will be created", -1 /* CACHED */)
                                                                ]))]))
                                                            : (row.state === 'NeedsChoice' && !_ctx.isDifferentLocation(row))
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                    _createCommentVNode(" Existing system at this site "),
                                                                    _createElementVNode("div", null, [
                                                                        _createElementVNode("div", _hoisted_35, [
                                                                            _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fa fa-exclamation-triangle text-warning" }, null, -1 /* CACHED */)),
                                                                            _cache[41] || (_cache[41] = _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tSystem ", -1 /* CACHED */)),
                                                                            _createElementVNode("strong", null, _toDisplayString((_b = (_a = row.preview) === null || _a === void 0 ? void 0 : _a.existingSystem) === null || _b === void 0 ? void 0 : _b.systemName), 1 /* TEXT */),
                                                                            _cache[42] || (_cache[42] = _createTextVNode(" already exists at this site.\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */))
                                                                        ]),
                                                                        _cache[45] || (_cache[45] = _createTextVNode()),
                                                                        _createElementVNode("div", _hoisted_36, [
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                class: "form-check-input",
                                                                                type: "radio",
                                                                                name: `choice-${row.key}`,
                                                                                id: `override-${row.key}`,
                                                                                value: "override",
                                                                                "onUpdate:modelValue": ($event) => ((row.choice) = $event),
                                                                                disabled: _ctx.busy
                                                                            }, null, 8 /* PROPS */, _hoisted_37), [
                                                                                [_vModelRadio, row.choice]
                                                                            ]),
                                                                            _cache[43] || (_cache[43] = _createTextVNode()),
                                                                            _createElementVNode("label", {
                                                                                class: "form-check-label",
                                                                                for: `override-${row.key}`,
                                                                                title: "Existing components are updated by code, new ones are added; duplicate snapshots and events are skipped."
                                                                            }, "Override (update/merge)", 8 /* PROPS */, _hoisted_38)
                                                                        ]),
                                                                        _cache[46] || (_cache[46] = _createTextVNode()),
                                                                        _createElementVNode("div", _hoisted_39, [
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                class: "form-check-input",
                                                                                type: "radio",
                                                                                name: `choice-${row.key}`,
                                                                                id: `archive-${row.key}`,
                                                                                value: "archive",
                                                                                "onUpdate:modelValue": ($event) => ((row.choice) = $event),
                                                                                disabled: _ctx.busy
                                                                            }, null, 8 /* PROPS */, _hoisted_40), [
                                                                                [_vModelRadio, row.choice]
                                                                            ]),
                                                                            _cache[44] || (_cache[44] = _createTextVNode()),
                                                                            _createElementVNode("label", {
                                                                                class: "form-check-label",
                                                                                for: `archive-${row.key}`,
                                                                                title: "The existing system and its components are renamed with an _ARCHIVED_ suffix and marked as deleted; a new system is created."
                                                                            }, "Archive and create new", 8 /* PROPS */, _hoisted_41)
                                                                        ])
                                                                    ])
                                                                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                                : (row.state === 'NeedsChoice')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                        _createCommentVNode(" Existing system elsewhere "),
                                                                        _createElementVNode("div", null, [
                                                                            _createElementVNode("div", _hoisted_42, [
                                                                                _cache[47] || (_cache[47] = _createElementVNode("i", { class: "fa fa-exclamation-circle text-danger" }, null, -1 /* CACHED */)),
                                                                                _cache[48] || (_cache[48] = _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tRegistered as ", -1 /* CACHED */)),
                                                                                _createElementVNode("strong", null, _toDisplayString((_d = (_c = row.preview) === null || _c === void 0 ? void 0 : _c.existingSystem) === null || _d === void 0 ? void 0 : _d.systemName), 1 /* TEXT */),
                                                                                _createTextVNode(" at\r\n\t\t\t\t\t\t\t\t\t\t" + _toDisplayString((_f = (_e = row.preview) === null || _e === void 0 ? void 0 : _e.existingSystem) === null || _f === void 0 ? void 0 : _f.companyName) + " / " + _toDisplayString((_h = (_g = row.preview) === null || _g === void 0 ? void 0 : _g.existingSystem) === null || _h === void 0 ? void 0 : _h.siteName) + ".\r\n\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                                            ]),
                                                                            _cache[50] || (_cache[50] = _createTextVNode()),
                                                                            _createElementVNode("div", _hoisted_43, [
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    class: "form-check-input",
                                                                                    type: "checkbox",
                                                                                    id: `move-${row.key}`,
                                                                                    "onUpdate:modelValue": ($event) => ((row.archiveConfirmed) = $event),
                                                                                    disabled: _ctx.busy
                                                                                }, null, 8 /* PROPS */, _hoisted_44), [
                                                                                    [_vModelCheckbox, row.archiveConfirmed]
                                                                                ]),
                                                                                _cache[49] || (_cache[49] = _createTextVNode()),
                                                                                _createElementVNode("label", {
                                                                                    class: "form-check-label small",
                                                                                    for: `move-${row.key}`
                                                                                }, "\r\n\t\t\t\t\t\t\t\t\t\t\tI understand the existing system will be archived and the controller imported to the selected site.\r\n\t\t\t\t\t\t\t\t\t\t", 8 /* PROPS */, _hoisted_45)
                                                                            ])
                                                                        ])
                                                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                                                    : _createCommentVNode("v-if", true)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                    ]),
                                    _cache[57] || (_cache[57] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_46, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-outline-secondary btn-sm",
                                            disabled: _ctx.busy,
                                            title: "Remove",
                                            onClick: ($event) => (_ctx.removeRow(row))
                                        }, [...(_cache[54] || (_cache[54] = [
                                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */)
                                            ]))], 8 /* PROPS */, _hoisted_47)
                                    ])
                                ], 2 /* CLASS */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true),
            _cache[75] || (_cache[75] = _createTextVNode()),
            (_ctx.enqueueErrors.length)
                ? (_openBlock(), _createBlock(_component_b_alert, {
                    key: 4,
                    "model-value": true,
                    variant: "danger",
                    class: "mb-0"
                }, {
                    default: _withCtx(() => [
                        _cache[60] || (_cache[60] = _createElementVNode("p", { class: "mb-1 fw-bold" }, "Nothing was queued:", -1 /* CACHED */)),
                        _cache[61] || (_cache[61] = _createTextVNode()),
                        _createElementVNode("ul", _hoisted_48, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enqueueErrors, (error, index) => {
                                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1 /* TEXT */));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _cache[76] || (_cache[76] = _createTextVNode())
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onHidden"]));
}
